import * as React from 'react';

const Req = () => {
    return (
        <span style={{color: 'red'}}>*</span>
    )
}

export default Req